<main>
    <button on:click={readAllCars}>Read all</button>
    {#each cars as car}
        <div>{car.reg}, {car.make}</div>
    {/each}
</main>

<script>
    var cars = []
    $: cars = cars

    async function readAllCars() {
        const url = "/.netlify/functions/database-access";
        const context = {
            access_type: 'read-all'
        }
        const event_pack = {
                body: JSON.stringify(context),
                method: "PATCH",
                "Content-Type": "application/json",
            }
        const all_cars = await fetch(url, event_pack);
        let raw_cars = await all_cars.json();
        cars = []
        for (var car of raw_cars) {
            cars.push(car.data)
        }
    };
</script>
